import { useFlags } from "flagsmith/react";

const useFlag = (flagName: string) => {
  const { [flagName]: flag } = useFlags([flagName]);
  return flag && flag.enabled;
};

export { useFlag };
